/* eslint-disable import/prefer-default-export */
export const isLegacyConnected = () =>
  !!(
    window.parent &&
    window.parent.appVersionId &&
    window.parent.location &&
    window.parent.location.origin &&
    window.parent.location.origin === window.location.origin
  );
